import { useState } from 'react';
import { endImpersonation } from '../lib/api';
import { useAuthStore } from '../lib/auth-store';
import { queryClient } from '../lib/query-client';

/** Shown while an admin is using "Login as" on this member; returns them to the admin app. */
export function ImpersonationBanner() {
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);
  const [ending, setEnding] = useState(false);
  if (!user?.impersonator) return null;
  async function returnToAdmin() {
    setEnding(true);
    await endImpersonation();
    clear();
    queryClient.clear();
    window.location.href = import.meta.env.VITE_ADMIN_URL ?? 'http://localhost:5173';
  }
  return (
    <div className="sticky top-0 z-50 flex items-center justify-between gap-3 bg-destructive px-4 py-2 text-sm text-ink">
      <span>
        Acting as <strong>{user.email}</strong>. Your actions are logged under your admin account.
      </span>
      <button
        type="button"
        onClick={() => void returnToAdmin()}
        disabled={ending}
        className="border border-ink px-3 py-1 font-mono text-[0.62rem] uppercase tracking-[0.12em]"
      >
        {ending ? 'Returning' : 'Return to admin'}
      </button>
    </div>
  );
}
